import moment from 'moment';
import avatar from '../../assets/images/avatar.png';
import { useSelector } from 'react-redux';
import { formatUnreadCount } from '../../helpers/chatUtils';

const SingleChat = ({ item, index, selectedChat, handleCardClick, toggle }) => {
    const { userData } = useSelector((state) => state.user);
    const unreadCount = Number(item[userData?.id]) || 0;
    const unreadLabel = formatUnreadCount(unreadCount);
    const lastMessage = item?.lastMessage || '';
    const messagePreview =
        lastMessage.length > 32
            ? `${lastMessage.substring(0, 32)}...`
            : lastMessage || 'No messages yet';

    return (
        <div
            key={index}
            className={`chat-card ${
                item?.id === selectedChat?.id ? 'active' : ''
            } ${unreadCount > 0 ? 'unread' : ''}`}
            onClick={() => handleCardClick(index, item)}
        >
            <div
                className={`d-flex py-1 ${
                    !toggle
                        ? 'justify-content-between'
                        : 'justify-content-center'
                }`}
            >
                <div
                    className={`d-flex align-items-center ${
                        !toggle
                            ? 'gap-2 overflow-hidden'
                            : 'justify-content-center'
                    }`}
                >
                    <div className="position-relative flex-shrink-0">
                        <img
                            className="rounded-circle"
                            src={
                                item?.chatWithDetails?.profile_photo_path ||
                                avatar
                            }
                            alt="avatar"
                            width={toggle ? 36 : 40}
                            height={toggle ? 36 : 40}
                        />
                        {toggle && unreadLabel && (
                            <span className="chat-avatar-badge">
                                {unreadLabel}
                            </span>
                        )}
                    </div>
                    <div className={!toggle ? 'd-flex flex-row' : 'd-none'}>
                        <div className="d-flex flex-column overflow-hidden">
                            <h5 className="heading text-truncate d-flex align-items-center gap-1">
                                {item?.chatWithDetails?.name}
                                {item?.chatWithDetails?.role && (
                                    <span
                                        style={{
                                            fontSize: '8px',
                                            color: '#667085',
                                            fontWeight: 'normal',
                                            backgroundColor: '#f3f4f6',
                                            padding: '1px 4px',
                                            borderRadius: '5px',
                                        }}
                                    >
                                        {item.chatWithDetails.role ===
                                        'business'
                                            ? 'Business'
                                            : 'Customer'}
                                    </span>
                                )}
                            </h5>
                            <p className="message">{messagePreview}</p>
                        </div>
                    </div>
                </div>
                <div
                    className={
                        !toggle
                            ? 'd-flex flex-column align-items-end gap-1 flex-shrink-0'
                            : 'd-none'
                    }
                >
                    {unreadLabel && (
                        <span className="notification">{unreadLabel}</span>
                    )}
                    <span className="time">
                        {item?.updatedAt?.seconds &&
                            moment
                                .unix(item.updatedAt.seconds)
                                .format('hh:mm A')}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default SingleChat;
